import type { z } from 'zod';

import type { IdCompanyDto } from '@/services/ws-companies/src/main/resources/rest-api';

import type { createSchema } from './schema.ts';

export type FormValues = z.infer<ReturnType<typeof createSchema>>;

export interface CompanyFormRouteParams {
  companyId?: IdCompanyDto;
}

export enum CompanyFormSearchKey {
  COMPANY_DETAILS_TAB = 'companyDetailsTab',
}
